import React from "react";

const benefits = [
  "Flexible Learning Schedule",
  "Expert Instruction",
  "Diverse Course Offerings",
  "Updated Curriculum",
  "Practical Projects and Assignments",
  "Interactive Learning Environment",
];

const descriptions = [
  "Fit your coursework around your existing commitments and obligations.",
  "Learn from industry experts with hands-on experience.",
  "Explore a wide range of design & development programs.",
  "Access updated content reflecting latest industry trends.",
  "Build a portfolio that impresses employers.",
  "Collaborate, discuss, and grow with peers.",
];

const BenefitsFomUs = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      <div className="pointer-events-none absolute -top-36 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 right-10 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12 text-center">
        <h2
          className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900"
          data-aos="fade-up"
        >
          Benefits You{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
            Get From Us
          </span>
          !
        </h2>
        <p
          className="mt-4 text-slate-600 text-sm md:text-lg max-w-2xl mx-auto"
          data-aos="fade-up"
        >
          Experience personalized support, industry-driven curriculum, hands-on
          learning, and expert mentorship — all focused on your success.
        </p>

        {/* Cards */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={benefit}
              className="bg-white/80 backdrop-blur-lg border border-[#5989C8]/20 shadow-md hover:shadow-lg transition-all duration-300 rounded-2xl p-6 md:p-7 text-left flex flex-col"
              data-aos="fade-up"
              data-aos-delay={index * 80}
            >
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] to-[#064585] mb-3 md:mb-4 text-right">
                {(index + 1).toString().padStart(2, "0")}
              </div>

              <h3 className="text-lg md:text-xl font-semibold text-slate-800">
                {benefit}
              </h3>

              <p className="mt-2 text-slate-600 text-sm md:text-base leading-relaxed">
                {descriptions[index]}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsFomUs;
